<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      Convert Lead
    </div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/leads/detail?id=' + id_lead)" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-20 pt-0">
        <form @submit.prevent="validateRegister">
          <div class="font-bold mt-20">ID Number<span class="color-primary ml-10">#{{id_lead}}</span></div>
          <hr class="transparent">
          <div class="row mb-30">
            <div class="col-lg-12">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control bg-transparent border-bottom" disabled name="name" v-model="memberName" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Contact Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control bg-transparent border-bottom" disabled name="number" v-model="dataMember.phone_number" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Owner of the new member</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control bg-transparent border-bottom" disabled name="number" v-model="salesName" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="row mb-30 mt-30">
            <div class="col-md-6">
              <div class="font-bold">Payment Transaction</div>
              <hr class="short-line left mb-30">
              <div class="row">
                <div class="col-sm-3">
                  <div class="label-name">Transaction Date</div>
                </div>
                <div class="col-sm-9">
                  <flat-pickr :config="config2" v-model="saveData.created_at" name="created_date" class="w-100"></flat-pickr>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mb-40 mt-40">
            <div class="col-md-6">
              <div class="row">
                <div class="col-sm-3">
                  <div class="label-name">Branch Codename</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="branch_codename" @change="onChangeBranch" v-model="saveData.branch_codename" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option :value="'FT'" selected>FT (Free Trial)</option>
                    <option v-for="item in itemsBranch" :key="item.id" :value="item.codename">{{item.codename}} ({{item.name}})</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('branch_codename') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mb-3">
                <div class="col-sm-3">
                  <div class="label-name">Membership Category</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="type_membership_category" @change="changeMembershipCategory" v-model="membershipTypeId" class="form-control">
                    <option :value="''" selected>Please select</option>
                    <option :value="1" selected>Monthly</option>
                    <option :value="2" selected>Yearly</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('type_membership_category') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <div class="label-name">Type Membership</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="type_membership" @change="changeMembership" v-model="memberSelect" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsMembership" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('type_membership') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mt-30">
                <div class="col-sm-3">
                  <div class="label-name">Customer Service</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="customer_service" v-model="memberCs" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsCs" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('customer_service') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="membershipTypeId == 1">
              <div class="row mt-30">
                <div class="col-sm-3">
                  <div class="label-name">Pending FOP</div>
                </div>
                <div class="col-sm-9">
                  <input type="checkbox" id="pending_fop" name="checkbox_pending_fop" v-model="saveData.pending_fop" value />
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="detailMembership.membership_type_id == 2">
              <div class="row mt-30">
                <div class="col-sm-3">
                  <div class="label-name">Payment Type</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="membership_term_payment_type_id" v-model="saveData.membership_term_payment_type_id" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option value="1">Regular</option>
                    <option value="2">Installment</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('membership_term_payment_type_id') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="saveData.membership_term_payment_type_id == 2">
              <div class="row mt-30">
                <div class="col-sm-3">
                  <div class="label-name">Installment Month</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="installment_month" v-model="saveData.installment_month" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option value="3">3</option>
                    <option value="6">6</option>
                    <option value="12">12</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('installment_month') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="is_bundling_session">
              <div class="row mt-30">
                <div class="col-sm-3">
                  <div class="label-name">Personal Trainer</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select v-validate="'required'" name="session_personal_trainer" v-model="saveData.session_personal_trainer_id" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in dataPT" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('session_personal_trainer') }}</span>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mt-30 mb-30">
            <div class="col-lg-6">
              <b-row>
                <b-col sm="3">
                  <div class="label-name">Start Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" @on-change="changeDate" v-model="dataTimeAndMembership.start_membership_date" name="event_date" class="w-100"></flat-pickr>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="section-convert-table mb-30">
            <table class="table-convert">
              <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Terms</th>
                  <th colspan="2">Dues (Monthly Billing)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Processing Fee</td>
                  <td class="idr">IDR</td>
                  <td class="price">
                    <money class="form-control border-bottom text-right" v-model="price.processing_fee" v-bind="money"></money>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr :class="{'disable-row': checkboxProRate == true}">
                  <td>First Month</td>
                  <td class="idr">IDR</td>
                  <td class="price">
                    <money class="form-control border-bottom text-right" v-model="price.firstMonth" v-bind="money"></money>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr :class="{'disable-row': checkboxProRate == false}">
                  <td><input type="checkbox" v-model="checkboxProRate" :disabled="detailMembership.membership_type_id == 2 ? true : false" class="mr-5" value="">Pro Rate</td>
                  <td class="idr">
                    <template v-if="checkboxProRate === true">
                      <the-mask class="mr-10 bg-transparent" v-model="totalDays" disabled type="tel" mask="##" :masked="false"></the-mask><span class="mr-10">x</span>IDR
                    </template>
                    <template v-else>
                      <the-mask class="mr-10 bg-transparent" v-model="dummyValue" disabled type="tel" mask="##" :masked="false"></the-mask><span class="mr-10">x</span>IDR
                    </template>
                  </td>
                  <td>
                    <template v-if="checkboxProRate === true">
                      <money class="form-control border-bottom text-right" v-model="price.proRate" v-bind="money"></money>
                    </template>
                    <template v-else>
                      <money class="form-control border-bottom text-right bg-transparent" v-model="dummyValue" disabled v-bind="money"></money>
                    </template>
                  </td>
                  <td class="idr bg-transparent">IDR</td>
                  <td class="price bg-transparent">
                    <money class="form-control border-bottom text-right bg-transparent" v-model="price.montlyBilling" v-bind="money" disabled></money>
                  </td>
                </tr>
                <tr :class="{'disable-row': checkboxProRate == false}">
                  <td class="idr" colspan="2" v-if="!is_bundling_session"><span class="font-400">(Total Pro Rates)</span> IDR</td>
                  <td class="idr" colspan="2" v-if="is_bundling_session"><span class="font-400">(Pro Rates Session + Prorate Membership ({{basic_membership_bundling_price}}))</span> IDR</td>
                  <td class="price">
                    <money class="form-control border-bottom text-right bg-transparent" v-model="totalProRate" :value="calcProRate" v-bind="money2" disabled></money>
                  </td>
                  <td class="bg-transparent" colspan="2"></td>
                </tr>
                <tr>
                  <td>Last Month Rate</td>
                  <td class="idr">IDR</td>
                  <td class="price"><money class="form-control border-bottom text-right" v-model="price.lastMonth" v-bind="money"></money></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>Tax</td>
                  <td class="idr">IDR</td>
                  <td class="price">(included)</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td colspan="2" class="font-bold">Total 1st Time Payment</td>
                  <td colspan="2" class="font-bold">Next Month Payment</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="idr">IDR</td>
                  <td class="price">
                    <money class="form-control border-bottom text-right bg-transparent" v-model="totalPrice" :value="totalPayment" v-bind="money2" disabled></money>
                  </td>
                  <td class="idr">IDR</td>
                  <td class="price"><money class="form-control border-bottom text-right bg-transparent" v-model="price.nextMonthPayment" v-bind="money" disabled></money></td>
                </tr>
              </tbody>
            </table>

            <hr class="mt-40 mb-30">
            <div class="mb-10">
              <div class="row">
                <div class="col-lg-6">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <label>Voucher</label>
                    </b-col>
                    <b-col sm="9">
                      <div class="custom-search-select">
                        <model-select
                          autocomplete="false"
                          @input="onVoucherChange"
                          :options="itemVouchers"
                          class="border-bottom"
                          name="vouchers"
                          v-model="saveData.voucher_id"
                        ></model-select>
                      </div>
                      <span class="error">{{ errors.first('vouchers') }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-20" v-if="saveData.voucher_no">
                    <b-col sm="3">
                      <label>Voucher Amount</label>
                    </b-col>
                    <b-col sm="9">
                      <money
                        class="form-control border-bottom bg-transparent"
                        v-model="saveData.voucher_amount"
                        :value="redeemVoucher"
                        v-bind="money2"
                        disabled
                      ></money>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <label>Member Point</label>
                    </b-col>
                    <b-col sm="9">
                      <money
                        class="form-control border-bottom bg-transparent"
                        v-model="memberPoint"
                        v-bind="money2"
                        disabled
                      ></money>
                    </b-col>
                  </b-row>
                  <b-row class="mb-20" v-if="memberPoint > 0">
                    <b-col sm="3">
                      <label>Redeem Amount</label>
                    </b-col>
                    <b-col sm="9">
                      <money
                        class="form-control border-bottom bg-transparent"
                        v-model="redeemAmount"
                        :value="redeemPayment"
                        v-bind="money2"
                      ></money>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>

            <hr class="mt-40 mb-30">
            <div class="mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment1" v-model="paymentType1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('payment1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1" :disabled="[1,6, 9].includes(paymentType1)" name="paymentCard1" v-model="paymentCard1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                        <div v-if="![1,9].includes(paymentType1) && paymentType1 != null && paymentCard1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount" v-model="amountPaymentCard1" v-bind="money2"></money>
                  <!-- <div v-if="amountPaymentCard1 == 0">
                    <span class="error">The payment first amount field is required.</span>
                  </div> -->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="paymentType2" @change="changePaymentType2" v-model="paymentType2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2" :disabled="paymentType2 == 1 || paymentType2 == 6" name="paymentCard2" v-model="paymentCard2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="notesPayment"></textarea>
                </b-col>
              </div>
            </div>
          </div>
          <div class="text-right">
            <!-- <button @click="openPage('/leads/checkout?id=' + id_lead)" class="btn-border-primary">Card Registration</button> -->
            <button type="submit" class="btn-primary ml-10">Save</button>
          </div>
          <div v-if="loadingActive == true" class="loading-container">
            <div class="wrap-screen w-100 h-100">
              <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
              <div class="title-loading color-white">Loading...</div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import {Money} from 'v-money'
import { ModelSelect } from "vue-search-select";

export default {
  name: 'convertLead',
  components: {Money, ModelSelect},
  data: function () {
    return {
      memberPoint: 0,
      redeemAmount: 0,
      loadingActive: false,
      notesPayment: '',
      dummyValue: 0,
      checkboxProRate: false,
      memberCs: null,
      memberSelect: null,
      membershipTypeId: 1,
      totalDays: '',
      currentDaysInMonth: '',
      totalPrice: '',
      totalProRate: '',
      totalProRateAlphaSession: '',
      getSalesId: '',
      price: {
        processing_fee: '',
        montlyPrice: '',
        firstMonth: '',
        firstMonthFix: '',
        lastMonth: '',
        proRate: '',
        nextMonthPayment: '',
        montlyBilling: ''
      },
      dataPT: [],
      detailMembership: [],
      dataMember: [],
      itemsSales: [],
      itemsBranch: [],
      memberName: '',
      salesName: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      config: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d'
      },
      config2: {
        altInput: true,
        altFormat: 'j F Y, H:i',
        enableTime: true,
        time_24hr: true,
        dateFormat: 'Y-m-d H:i'
      },
      id_lead: '',
      dataTimeAndMembership: {
        start_membership_date: '',
        membership_id: ''
      },
      paymentCard1: null,
      paymentType1: null,
      paymentCard2: null,
      paymentType2: null,
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      itemsCs: [],
      itemsMembership: [],
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      itemVouchers: [],
      itemVouchers2: [],
      is_bundling_session : 0,
      basic_membership_bundling_price : 0,
      saveData: {
        session_personal_trainer_id: null,
        gross_amount: '',
        customer_service_id: '',
        member_id: '',
        transaction_type_id: 2,
        membership_id: '',
        start_membership_date: '',
        branch_id: '',
        branch_codename: null,
        first_month: '',
        last_month: '',
        processing_fee: '',
        pro_rate: '',
        monthly_rate: '',
        membership_term_payment_type_id: null,
        installment_month: null,
        payment_type_id_1: '',
        payment_card_id_1: '',
        payment_amount_1: '',
        payment_type_id_2: '',
        payment_card_id_2: '',
        payment_amount_2: '',
        notes: '',
        created_at: moment(new Date()).format('YYYY-MM-DD H:m'),
        member_voucher_id: null,
        voucher_id: null,
        voucher_no: null,
        voucher_amount: 0,
        redeem_amount: 0,
        pending_fop: false
      },
      saveTrxToLeads: {
        trx_id: '',
        doc_name: 'form_paradigm_1.hbs'
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      selectedIdBranch: null
    }
  },
  methods: {
    onChangeBranch(event) {
      const find = this.itemsBranch.find((m) => m.codename === event)
      console.log(find)
      if (find) {
        this.selectedIdBranch = find.id
        // cham
        this.fetchData()
      }
    },
    changePaymentType1 (event) {
      if (event === 1) {
        this.paymentCard1 = null
      } else if (event === 6) {
        this.paymentCard1 = 1
      } else {
        this.paymentCard1 = null
      }
    },
    async changePaymentCard1 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    changePaymentType2 (event) {
      if (event === 1) {
        this.paymentCard2 = null
      } else if (event === 6) {
        this.paymentCard2 = 1
      } else {
        this.paymentCard2 = null
      }
    },
    onVoucherChange(event) {
      const find = this.itemVouchers2.find((m) => m.voucher_id == event);
      if (find) {
        this.saveData.member_voucher_id = find.id
        this.saveData.voucher_no = find.voucher_no
        this.saveData.voucher_amount = find.voucher_amount
      } else {
        this.saveData.voucher_no = null
        this.saveData.member_voucher_id = null
        this.saveData.voucher_amount = 0
      }
    },
    changeMembershipCategory(ev) {
      this.membershipTypeId = ev

      axios.get('fitness/v1/membership?sorting=name&sorting_type=asc&status=active&branch_id='+ this.selectedIdBranch+'&category_id='+this.membershipTypeId).then(response => {
        this.itemsMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeMembership (event) {
      this.saveData.membership_id = event
      this.dataTimeAndMembership.membership_id = event
      let membership = this.itemsMembership.filter(row => row.id === event)[0]
      if (event === null) {
        this.detailMembership.processing_fee = 0
        this.detailMembership.price = 0
      } else {
        axios.get('fitness/v1/membership/' + event).then(response => {
          this.detailMembership = response.data.data
          this.price.processing_fee = response.data.data.processing_fee
          this.price.montlyPrice = response.data.data.price
          this.price.firstMonthFix = response.data.data.first_month
          this.price.firstMonth = response.data.data.first_month
          this.price.lastMonth = response.data.data.last_month

          this.is_bundling_session = response.data.data.is_bundling_session
          this.basic_membership_bundling_price = response.data.data.basic_membership_bundling_price

          if(this.is_bundling_session){
            axios.get('fitness/v1/alpha_session_prorate/session_qty?start_membership_date=' + this.dataTimeAndMembership.start_membership_date + '&membership_id=' + this.memberSelect).then(response => {
              this.price.proRate = response.data.data.session_price
              this.totalDays = response.data.data.session_qty
              this.totalProRateAlphaSession = response.data.data.total_prorate
            }).catch(error => {
              console.log('error', error)
            })
          }else{
            this.price.proRate = response.data.data.price / this.currentDaysInMonth
            this.totalDays = (moment(new Date()).daysInMonth() - moment(new Date()).format('DD')) + 1
          }

          if (response.data.data.membership_type_id === 2 || membership.is_advocacy) {
            this.$nextTick(() => {
              this.price.montlyBilling = 0
              this.price.nextMonthPayment = 0
            })
          } else {
            let montlyBilling = response.data.data.price + 2200
            this.price.montlyBilling = montlyBilling
            let nextMonthPayment = response.data.data.price + 2200
            this.price.nextMonthPayment = nextMonthPayment
          }
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    changeDate (event) {
      this.currentDaysInMonth = moment(new Date(event)).daysInMonth()

      if(this.is_bundling_session){
        let start_membership_date = moment(new Date(event)).format('YYYY-MM-DD')
        axios.get('fitness/v1/alpha_session_prorate/session_qty?start_membership_date=' + start_membership_date + '&membership_id=' + this.memberSelect).then(response => {
          this.price.proRate = response.data.data.session_price
          this.totalDays = response.data.data.session_qty
          this.totalProRateAlphaSession = response.data.data.total_prorate
        }).catch(error => {
          console.log('error', error)
        })
      }else{
        this.totalDays = (moment(new Date(event)).daysInMonth() - moment(new Date(event)).format('DD')) + 1
        this.price.proRate = this.price.montlyPrice / moment(new Date(event)).daysInMonth()
        this.dataTimeAndMembership.start_membership_date = moment(new Date(event)).format('YYYY-MM-DD')
      }
    },
    validateRegister () {
      this.loadingActive = true
      this.$validator.validateAll().then((result) => {
        if (![1,9].includes(this.paymentType1) && this.paymentCard1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          this.loadingActive = false
          return
        }

        if(result) {
          this.saveData.gross_amount = this.totalPrice
          this.saveData.member_id = this.dataMember.member_id
          this.saveData.start_membership_date = this.dataTimeAndMembership.start_membership_date
          this.saveData.first_month = this.price.firstMonth
          this.saveData.last_month = this.price.lastMonth
          this.saveData.processing_fee = this.price.processing_fee
          this.saveData.pro_rate = this.totalProRate
          this.saveData.monthly_rate = this.price.montlyPrice
          this.saveData.payment_type_id_1 = this.paymentType1
          this.saveData.payment_card_id_1 = this.paymentCard1
          this.saveData.payment_amount_1 = this.amountPaymentCard1
          this.saveData.payment_type_id_2 = this.paymentType2
          this.saveData.payment_card_id_2 = this.paymentCard2
          this.saveData.payment_amount_2 = this.amountPaymentCard2
          this.saveData.redeem_amount = this.redeemAmount
          this.saveData.notes = this.notesPayment
          this.saveData.customer_service_id = this.memberCs
          this.saveData.pending_fop = this.saveData.pending_fop ? 1 : 0

          if (this.detailMembership.membership_type_id == 2) {
            this.saveData.transaction_type_id = 12
          }
          axios.post('transaction/v1/payment/save_transaction', this.saveData).then(response => {
            this.saveTrxToLeads.trx_id = response.data.data.id
            this.saveTrxToLeads.customer_service_id = this.memberCs
            this.saveTrxToLeads.is_member = true
            this.saveTrxToLeads.leads_status_id = 2 // Membership - task/004, status lead ikut jadi "Membership" saat sudah convert
            axios.put('crm/v1/leads/' + this.id_lead, this.saveTrxToLeads).then(response => {
              this.loadingActive = false

              if (this.saveData.pending_fop != 1) {
                // send email
                axios.post("crm/v1/form_aggreement/html_generate",this.saveTrxToLeads).then(response => {
                      setTimeout(() => {
                          this.$toast.success("Email has been sent!", "Success", {
                          position: "topCenter",
                          icon: "icon-envelope",
                          progressBarColor: "rgb(0, 255, 184)",
                          theme: "dark",
                          backgroundColor: "#565c70",
                          messageColor: "#fff"
                        });
                      }, 1500);
                })
              }

              this.$router.push('/leads/detail?id=' + this.id_lead)
              this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }).catch(error => {
              this.loadingActive = false
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })

          }).catch(error => {
            console.log('error', error.response)
            if (error.response.data) {
              this.loadingActive = false
              this.$toast.success(error.response.data.error, 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            } else {
              this.loadingActive = false
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.loadingActive = false
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      this.dataTimeAndMembership.start_membership_date = moment(new Date()).format('YYYY-MM-DD')
      this.currentDaysInMonth = moment(new Date()).daysInMonth()

      if(this.is_bundling_session){
        axios.get('fitness/v1/alpha_session_prorate/session_qty?start_membership_date=' + this.dataTimeAndMembership.start_membership_date + '&membership_id=' + this.memberSelect).then(response => {
          this.totalDays = response.data.data.session_qty
          this.totalProRateAlphaSession = response.data.data.total_prorate
        }).catch(error => {
          console.log('error', error)
        })
      }else{
        this.totalDays = (moment(new Date()).daysInMonth() - moment(new Date()).format('DD')) + 1
      }

      axios.get('crm/v1/customer_service?status=active&sorting=name&sorting_type=asc&branch_id='+ this.selectedIdBranch).then(response => {
        this.itemsCs = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/membership?sorting=name&sorting_type=asc&status=active&branch_id='+ this.selectedIdBranch+'&category_id='+this.membershipTypeId).then(response => {
        this.itemsMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
        this.itemsPaymentType = response.data.data.rows
        this.itemsPaymentType2 = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.itemsBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/leads/' + this.$route.query.id).then(response => {
        this.dataMember = response.data.data
        this.saveData.branch_id = response.data.data.sale ? response.data.data.sale.branch_id : ''
        this.memberName = response.data.data.first_name + ' ' + response.data.data.last_name
        this.salesName = response.data.data.sale.fullname
        this.saveTrxToLeads.doc_name = response.data.data.doc_name
        // console.log(this.saveTrxToLeads)

        // load member point
        axios.get("mobile/v1/my_rewards/total_rewards?member_id="+response.data.data.member_id)
          .then(response => {
            this.memberPoint = response.data.data[0].total_amount === null ? 0 : response.data.data[0].total_amount
          })
          .catch(error => {
            console.log("error", error);
          });

          axios.get("transaction/v1/member_voucher?page=1&limit=20&member_id="+response.data.data.member_id)
          .then(response => {
              this.itemVouchers2 = response.data.data.rows;
              this.itemVouchers = [];
              this.itemVouchers.push({ value: null, text: "Please select" })
              for (let i = 0; i < response.data.data.rows.length; i++) {
                const el = response.data.data.rows[i];
                this.itemVouchers.push({ value: `${el.voucher_id}`, text: `${el.voucher_no} @Rp.${el.voucher_amount}` })
              }
            })
            .catch(error => {
              console.log("error", error);
            });

      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc').then(response => {
        this.dataPT = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  computed: {
    totalPayment: function() {
      if (this.checkboxProRate === true) {
        // let calculatedTotal = this.price.processing_fee + this.totalProRate + this.price.lastMonth
        let calculatedTotal = this.price.lastMonth + this.price.processing_fee + this.totalProRate
        this.totalPrice = calculatedTotal - this.saveData.voucher_amount - this.redeemAmount
        this.amountPaymentCard1 = this.totalPrice
        return calculatedTotal
      } else {
        let calculatedTotal = this.price.processing_fee + this.price.firstMonth + this.price.lastMonth
        this.totalPrice = calculatedTotal - this.saveData.voucher_amount - this.redeemAmount
        this.amountPaymentCard1 = this.totalPrice
        return calculatedTotal
      }
    },
    calcProRate: function() {
      if (this.checkboxProRate === true) {
        let calculatedTotal
        if(this.is_bundling_session){
          calculatedTotal = this.totalProRateAlphaSession
          this.totalProRate = calculatedTotal
        }else{
          calculatedTotal = this.totalDays * this.price.proRate
          this.totalProRate = calculatedTotal
        }
        this.price.firstMonth = 0
        return calculatedTotal
      } else {
        let calculatedTotal = 0
        this.totalProRate = calculatedTotal
        this.price.firstMonth = this.price.firstMonthFix
        return calculatedTotal
      }
    },
    redeemVoucher: function() {
      // this.totalPrice = this.totalPrice - this.saveData.voucher_amount
      return this.saveData.voucher_amount
    },
    paymentLeft: function() {
      if (String(this.amountPaymentCard1).length > String(this.totalPrice).length) {
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.totalPrice - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    },
    redeemPayment: function() {
      if (this.redeemAmount > this.memberPoint) {
        this.$toast.success("Not enough point", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.redeemAmount = 0;
        return this.redeemAmount
      } else {
        return this.redeemAmount
      }
    },
  },
  created () {
    this.fetchData()
    this.id_lead = this.$route.query.id
  }
}
</script>

<style>
</style>
